// Video.js includes multi-language support, ships with language files but
// so our translations are all in one place we create our own 'language' using polyglot.
export const videoJsOptions = () => ({
  playsinline: true,
  fluid: true,
  languages: {
    polyglot: {
      Play: polyglot.t('video_player.play'),
      Pause: polyglot.t('video_player.pause'),
      'Current Time': polyglot.t('video_player.current_time'),
      'Duration Time': polyglot.t('video_player.duration_time'),
      'Remaining Time': polyglot.t('video_player.remaining_time'),
      'Stream Type': polyglot.t('video_player.stream_type'),
      LIVE: polyglot.t('video_player.live'),
      Loaded: polyglot.t('video_player.loaded'),
      Progress: polyglot.t('video_player.progress'),
      Fullscreen: polyglot.t('video_player.fullscreen'),
      'Non-Fullscreen': polyglot.t('video_player.non_fullscreen'),
      Mute: polyglot.t('video_player.mute'),
      Unmute: polyglot.t('video_player.unmute'),
      'Playback Rate': polyglot.t('video_player.playback_rate'),
      Subtitles: polyglot.t('video_player.subtitles'),
      'subtitles off': polyglot.t('video_player.subtitles_off'),
      Captions: polyglot.t('video_player.captions'),
      'captions off': polyglot.t('video_player.captions_off'),
      Chapters: polyglot.t('video_player.chapters'),
      Descriptions: polyglot.t('video_player.descriptions'),
      'descriptions off': polyglot.t('video_player.descriptions_off'),
      'You aborted the media playback': polyglot.t(
        'video_player.aborted_playback',
      ),
      'A network error caused the media download to fail part-way.': polyglot.t(
        'video_player.network_error',
      ),
      'The media could not be loaded, either because the server or network failed or because the format is not supported.':
        polyglot.t('video_player.media_fail_network_or_format'),
      'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.':
        polyglot.t('video_player.media_corrupted_or_browser_incompatibility'),
      'No compatible source was found for this media.': polyglot.t(
        'video_player.no_compatible_source',
      ),
      'Play Video': polyglot.t('video_player.play_video'),
      Close: polyglot.t('video_player.close'),
      'Modal Window': polyglot.t('video_player.model_window'),
      'This is a modal window': polyglot.t('video_player.this_is_a_modal'),
      'This modal can be closed by pressing the Escape key or activating the close button.':
        polyglot.t('video_player.modal_close'),
      ', opens captions settings dialog': polyglot.t(
        'video_player.opens_captions_dialog',
      ),
      ', opens subtitles settings dialog': polyglot.t(
        'video_player.opens_subtitles_dialog',
      ),
      ', opens descriptions settings dialog': polyglot.t(
        'video_player.opens_descriptions_dialog',
      ),
      ', selected': polyglot.t('video_player.selected'),
    },
  },
  controlBar: {
    children: {
      playToggle: {},
      durationDisplay: {},
      progressControl: {},
      remainingTimeDisplay: {},
      liveDisplay: {},
      timeDivider: {},
      muteToggle: {},
      volumeControl: {},
      fullscreenToggle: {},
    },
  },
});

export const PopOutButton = 'popOutButton';
export const PopOutButtonClicked = 'popOutButtonClicked';
export const CloseFullscreenButton = 'CloseFullscreenButton';
export const CloseFullscreenButtonClicked = 'CloseFullscreenButtonClicked';
export const PlaybackEnded = 'ended';
